import axios from "axios";
// axios.defaults.baseURL = `${process.env.REACT_APP_BASEURL}`;

axios.defaults.baseURL = `https://app.jntuweb.com/api`;
// axios.defaults.baseURL = `http://localhost:1337/api`;

const instance = axios.create({
  baseURL: axios.defaults.baseURL,
});

// instance.defaults.headers.common[
//   "Authorization"
// ] = `Bearer ${localStorage.getItem("pickup-ninja-token")}`;
export default instance;
